import { withStylePrefix } from '../common/withStylePrefix';
import { SquircleButtonComponent, squircleButtonTemplate } from './SquircleButton';
import styles from './SquircleButton.styles.scss';
export const chameleonSquircleButton = SquircleButtonComponent.compose({
    baseName: 'squircle-button',
    template: squircleButtonTemplate,
    styles: withStylePrefix(styles),
});
